<template>
  <v-card height="640" flat>
    <v-card-title>Media</v-card-title>
    <hr />
    <v-card-subtitle>The following media assets are available:</v-card-subtitle>
    <v-container>
      
          <v-row>
            <v-col cols="12" md="3">
              <v-card class="mx-auto" max-width="344">
                <v-img src="@/assets/mediaImg.jpg" height="200px" />
                <v-card-title>300 dpi logo</v-card-title>

                <v-card-subtitle>Click below to download image</v-card-subtitle>

                <v-card-actions>
                  <v-btn @click="downloadItem('/mediaImg.jpg','geoAd_Logo_300dpi.jpg')">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card class="mx-auto" max-width="344">
                <v-img src="@/assets/mediaImg.jpg" height="200px" />
                <v-card-title>150 dpi logo</v-card-title>

                <v-card-subtitle>Click below to download image</v-card-subtitle>

                <v-card-actions>
                  <v-btn @click="downloadItem('/mediaImg.jpg','geoAd_Logo_150dpi.jpg')">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
             <v-col cols="12" md="3">
              <v-card class="mx-auto" max-width="344">
                <v-img src="@/assets/mediaImg.jpg" height="200px" />
                <v-card-title>96 dpi logo</v-card-title>

                <v-card-subtitle>Click below to download image</v-card-subtitle>

                <v-card-actions>
                  <v-btn @click="downloadItem('/mediaImg.jpg','geoAd_Logo_96dpi.jpg')">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
             <v-col cols="12" md="3">
              <v-card class="mx-auto" max-width="344">
                <v-img src="@/assets/GeoAD_Flyer.png" height="200px" />
                <v-card-title>Sales Page</v-card-title>

                <v-card-subtitle>Click below to download image</v-card-subtitle>

                <v-card-actions>
                  <v-btn @click="downloadItem('/GeoAD_Flyer.png','GeoAD_Flyer.png')">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
         
         
        
    </v-container>
  </v-card>
</template>
<script>
import axios from "axios";
export default {
  methods: {
    downloadItem(url, label) {
      axios
        .get(url, { responseType: "blob" })
        .then(response => {
          const blob = new Blob([response.data], { type: "image/png" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, label);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            window.open(objectUrl);
          }
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    }
  }
};
</script>
<style scoped>
</style>